const businessTab = {
  foundInSelectedSectors: 'Found in selected sectors',
  businesses: 'Businesses',
};

export default businessTab;
